import { render, staticRenderFns } from "./AddressesBook.vue?vue&type=template&id=2cc929fa&"
import script from "./AddressesBook.vue?vue&type=script&lang=js&"
export * from "./AddressesBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cc929fa')) {
      api.createRecord('2cc929fa', component.options)
    } else {
      api.reload('2cc929fa', component.options)
    }
    module.hot.accept("./AddressesBook.vue?vue&type=template&id=2cc929fa&", function () {
      api.rerender('2cc929fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/AddressesBook.vue"
export default component.exports